import { useState } from "react";
import MouseDot from "../../components/Ui/MouseDot";
import Footer from "../../components/Footer";
import useUiStore from "../../components/store/uiStore";

export default function AdminLayout({ children }) {
    const [footerActive, setFooterActive] = useState(false);
    const showForm = useUiStore((state) => state.showForm);

    return (
        <div className="admin-layout">
            {children}
            <Footer setFooterActive={setFooterActive} />
            <MouseDot footerActive={footerActive} onClick={showForm} />
        </div>
    );
}
